/**
 * Calculate scale
 * @param {Dimensions} rawSize - Raw size
 * @param {Dimensions} size - Target size
 * @param {boolean} [isUniformScale=false] - Uniform scale flag
 * @returns {import('./types').ScaleRatio} - Scale ratio
 */
export const calcScale = (rawSize, size, isUniformScale = false) => {
    if (!rawSize) {
        return {scaleX: 1, scaleY: 1}
    }

    if (!size) {
        return {scaleX: 1, scaleY: 1}
    }

    /**
     * Normalize rawSize
     */
    const raw = typeof rawSize === 'number' ? {width: rawSize, height: rawSize} : rawSize
    if (!Number.isFinite(raw.width) || !Number.isFinite(raw.height)) {
        throw new Error('Cannot calculate scale: invalid rawSize')
    }

    /**
     * Normalize target size
     */
    const target = typeof size === 'number' ? {width: size, height: size} : size
    if (!Number.isFinite(target.width) || !Number.isFinite(target.height)) {
        throw new Error('Cannot calculate scale: invalid size')
    }

    /**
     * Non-uniform scale (default)
     */
    if (!isUniformScale) {
        return {
            scaleX: target.width / raw.width,
            scaleY: target.height / raw.height,
        }
    }

    /**
     * Uniform scale (keep aspect ratio)
     */
    const scale = Math.min(target.width / raw.width, target.height / raw.height)

    return {
        scaleX: scale,
        scaleY: scale,
    }
}

